/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { useState } from "react";
import Modal from "react-modal";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onChange?: () => void;
};

const WorkspaceExitModal = (props: Props) => {
  const workspaceInfo = useRecoilValue(workspace);
  const { modalIsOpen, closeModal, onChange } = props;
  const [workspaceName, setWorkspaceName] = useState<string>();

  const enabledBtn = () => {
    return workspaceInfo?.name === workspaceName;
  };

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIcon onClick={closeModal}>
          <UI.Icon name="x" size={24} />
        </CancelIcon>
        <CautionIcon>
          <UI.Icon name="inform" size={56} color="var(--alias-color-status-negative)" />
        </CautionIcon>
        <InfoContainer>
          <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)" style={{wordBreak: "keep-all"}}>
            "{workspaceInfo?.name ?? "-"}" 워크스페이스에서 나가시겠습니까?
          </UI.Typography>
          <UI.Typography
            type="body01 normal"
            fontStyle="medium"
            color="var(--alias-color-label-alternative)"
          >
            워크스페이스 내 나의 기존 데이터가 모두 삭제됩니다.<br/>
            입력창에 삭제하려는 워크스페이스명을 입력해 주세요.<br/>
            <span
              css={css`
                color: var(--alias-color-status-negative);
              `}
            >
              ※ 워크스페이스의 유일한 Owner라면, 워크스페이스 내 모든 데이터가 영구 삭제됩니다.
            </span>
          </UI.Typography>
          <UI.Input placeholder={workspaceInfo?.name} value={workspaceName} onChange={setWorkspaceName} />
        </InfoContainer>
        <ButtonContainer>
          <UI.Button
            type="outlined"
            title="워크스페이스 나가기"
            size="large"
            disabled={!enabledBtn()}
            style={{ width: "100%" }}
            onClick={enabledBtn() ? onChange : () => {}}
          />
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default WorkspaceExitModal;

const Container = styled.div`
  width: 454px;
  padding: 48px;
  box-sizing: border-box;
  background-color: white;
  box-shadow: var(--alias-style-shadow-heavy);
  border-radius: 20px;
  position: relative;
  align-items: center;
  text-align: center;
`;

const CancelIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const CautionIcon = styled.div`
  box-shadow: 0px 0px 40px 0px rgba(255, 62, 62, 0.4);
  width: 47px;
  height: 47px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 24px;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 40px;
`;
